import { stmHttpClient, httpManager as http } from '@/plugins/HttpManager';
import { config } from 'CONFIG';
import { downLoad, cutArray, objectToQueryString, batchRequest } from '@/common/js/utils';
import { getCountryList } from '@/api/s3Config';
import { fetchStream } from './stream';
import { getResponseContentDisposition } from '@/utils/url/s3';
import { ICommonRes } from '../interface';
import { getSubDeviceList } from './subscriptions';
import { EAssociateFailedReason, IDeviceAssociation, IGetCloudCountriesResponse, IGetCloudVideoByIdRes, IQueryVideoQuantityByPeriodArgs, IReolinkDevice, ITotalDevice, IBatchDeviceAssociationResponse, IChangeAssociateDevicesArgs, IChangeAssociateDevicesResponse, IDeviceAssociationResultItem } from '@reolink-cloud/interface';
import { Array as ArrayUtils } from '@reolink-web/utils';

const timeStamp = process.env.TIME_STAMP;

export const getAlarmTypeList = (): Promise<ICommonRes> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/alarm-types/` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getOtherList = ( opts: { videoId: string; count: number; order_way: string; ownerId: string; }): any => {

    const cTime = new Date().getTime();

    return new Promise(( resolve, reject ) => {

        stmHttpClient.get( `/cloud/videos/records/?start_at=0&end_at=${cTime}&start_index=${opts.videoId}&count=${opts.count ? opts.count : 10}&order_way=${opts.order_way ? opts.order_way : 'desc'}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getVideoUrls = async ( type: string, id: string[] ): Promise<ICommonRes<{ url: string; }>> => {

    const { data } = await stmHttpClient.get( `/cloud/videos/records/urls/?type=${type}&${id.map( item => `id=${item}` ).join( ',' )}` );

    return data;

};

export const getVideoInfoById = ( videoId: string ): Promise<IGetCloudVideoByIdRes> => {

    return new Promise(( resolve, reject ) => {

        stmHttpClient.get( `/cloud/videos/records/${videoId}/` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const downloadVideo = async (
    videoId: string,
    encryptedHeaders: string,
    encrypt?: any,
    keySeed?: string
): Promise<void> => {

    const [data, headers] = await Promise.all( [
        getVideoUrls( 'download', [videoId] ),
        encryptedHeaders
    ] );

    const videoUrl = data.items[0].url;

    let downloadUrl = videoUrl;

    let responseContentDisposition;

    if ( headers ) {

        responseContentDisposition = getResponseContentDisposition( videoUrl );
        downloadUrl = await fetchStream(
            downloadUrl,
            { headers, timeout: void 0 },
            encrypt?.mode === 'native-encrypt' ? encrypt : undefined,
            keySeed
        );

    }

    downLoad( downloadUrl, `${videoId}.mp4`, responseContentDisposition );

};

export const deleteVideo = ( videoId: number | number[] ): Promise<any> => {

    let str = '';
    if ( typeof videoId === 'number' ) {

        str = `id=${videoId}`;

    } else if ( videoId instanceof Array ) {

        const newVideoId = videoId.map( item => {

            return `id=${item}`;

        });
        str = newVideoId.join( '&' );

    }
    return new Promise(( resolve, reject ) => {

        http.delete( `/videos/?${str}` ).then( res => {

            resolve( res );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getDeviceList = (): Promise<IReolinkDevice[]> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/devices` ).then( res => {

            resolve( res.data.items );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getTrafficDeviceTotal = ( bound = true ): Promise<any[]> => {

    return new Promise(( resolve, reject ) => {

        getDeviceList().then( res => {

            const devicesListAll = res;
            let uidAll;
            if ( bound ) {

                uidAll = devicesListAll.filter( item => item.status === 'bound' ).map( item => item.uid );

            } else {

                uidAll = devicesListAll.map( item => item.uid );

            }
            const result: any[] = [];
            for ( const uid of uidAll ) {

                const data = devicesListAll.filter( item => item.uid === uid )[0];
                result.push({
                    ...data,
                    model: data.model.title,
                    modelTitle: data.model.title
                });

            }
            resolve( result );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getDeviceTotal = ( deviceStatuses: string[] = ['bound'] ): Promise<ITotalDevice[]> => {

    return new Promise(( resolve, reject ) => {

        Promise.all( [

            getSubDeviceList(),
            getDeviceList()

        ] ).then( res => {

            const [deviceList, devicesListAll] = res;
            const uidSub = deviceList.filter( item => ( item.status === 'associated' || item.unassociationReason === 'expired' )).map( item => item.uid );
            const uidAll = devicesListAll.filter( item => deviceStatuses.includes( item.status )).map( item => item.uid );
            const result: any[] = [];
            // 有套餐的设备
            for ( const uid of uidSub ) {

                if ( !uidAll.includes( uid )) {

                    continue;

                }
                const dataT: any = deviceList.filter( item => item.uid === uid )[0];
                const data: any = devicesListAll.filter( item => item.uid === uid )[0];
                dataT.title = data.title;
                dataT.model = data.model.title;
                dataT.modelTitle = data.model.title;
                dataT.features = data.features;
                dataT.modelId = data.model.id;
                dataT.boundStatus = data.status;
                result.push( dataT );

            }

            const restUidArr = ArrayUtils.diff( uidAll, uidSub );
            // 没有套餐的设备
            for ( const uid of restUidArr ) {

                const data: any = devicesListAll.filter( item => item.uid === uid )[0];
                if ( !data ) {

                    continue;
                
                }

                result.push({
                    uid: data.uid,
                    title: data.title,
                    model: data.model.title,
                    modelTitle: data.model.title,
                    modelId: data.model.id,
                    status: 'unassociated',
                    subscription: '',
                    videoRetentionDays: 90,
                    plan: '',
                    hasEmbeddedSim: deviceList.find( item => item.uid === data.uid )?.hasEmbeddedSim,
                    boundStatus: data.status,
                });

            }
            resolve( result );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getDeviceIdsHasVideo = (): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.get( '/videos/devices' ).then( res => {

            resolve( res.data.items );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getDeviceInfoHasVideo = (): Promise<any> => {

    return new Promise<any[]>(( resolve, reject ) => {

        Promise.all( [

            getDeviceIdsHasVideo(),
            getSubDeviceList(),
            getDeviceList()

        ] ).then(( res ) => {

            const [ids, devices, accountDevices] = res;
            for ( const subDevice of devices ) {

                for ( const device of accountDevices ) {

                    if ( device.uid === subDevice.uid && device.title !== subDevice.title ) {

                        subDevice.title = device.title;

                    }

                }

            }
            let result: any[] = [];
            // 有视频的设备uid，有视频一定会有关联记录
            ids.map(( item ) => result.push( item.uid ));
            if ( ids.length && devices.length ) {

                // 有视频的设备
                result = devices.filter(({ uid }) => {

                    for ( const item of ids ) {

                        if ( uid === item.uid ) {

                            return true;

                        }

                    }

                });

            }
            // 已关联套餐的设备uid
            for ( const device of devices ) {

                if ( device.status === 'associated' ) {

                    result.push( device );

                }

            }
            // 新建一个对象记录uid并使用for循环去重;
            const finalResult: any[] = [];
            const obj = {};
            for ( const item of result ) {

                if ( !obj[item.uid] ) {

                    for ( const device of accountDevices ) {

                        if ( device.uid === item.uid ) {

                            item.boundStatus = device.status;
                            item.features = typeof device.features === 'undefined' ? {} : device.features;

                        }

                    }
                    finalResult.push( item );
                    obj[item.uid] = true;

                }

            }
            resolve( finalResult );

        }).catch( err => {

            reject( err );

        });

    });

};

export const updateVideoTitle = ( videoId: string, title: string ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.patch( `/videos/${videoId}`, { 'title': title }).then( res => {

            resolve( res );

        }).catch( err => {

            reject( err );

        });

    });

};

export function getSupportedCountriesCodes(): Promise<any[]> {

    return new Promise(( resolve, reject ) => {

        http.get( `/storage/availabilities/?client_id=${config.clientId}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

}

export const getSupportedCountries = async ( isCountriesValid: boolean, supportedCountriesCodesIn = [] ): Promise<Array<Record<string, string>>> => {

    let countryList: any[] = [];
    let supportedCountriesCodes: any[] = supportedCountriesCodesIn;
    if ( isCountriesValid ) {

        // * supportedCountriesCodes 表单支持国家单独处理
        countryList = await getCountryList();

    } else {

        [countryList, supportedCountriesCodes] = await Promise.all( [
            getCountryList(),
            getSupportedCountriesCodes()
        ] );

    }

    return countryList.filter(
        ( country: any ) => supportedCountriesCodes.includes( country.code )
    ).map(
        ( country: any ) => {

            return {

                code: country.code as string,
                text: country.name as string,
                image: `https://home-cdn.reolink.us/wp-content/assets/carrier/${country.name.toLowerCase().split( ' ' ).join( '_' )}.png?sv=${timeStamp!}`

            };

        }
    );

};

export const getVideoQuantityByPeriod = ( args: IQueryVideoQuantityByPeriodArgs ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/quantity/${objectToQueryString( args )}` ).then( res => {

            resolve( res.data.items );

        }).catch( err => {

            reject( err );

        });

    });

};

const getUserUsageAPI = ( queryString: string ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.get( `/videos/usage/?${queryString}` ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getUserUsage = async ( deviceArr: string[] ): Promise<ICommonRes> => {

    const newArr = deviceArr.map(( item: string ) => `uid=${item}` );

    // 分批请求，解决接口请求过长的问题
    const reqList = cutArray( newArr, 50 ).map(( subList: any ) => {

        return getUserUsageAPI( subList.join( '&' ));

    });

    const usageGroup: any[] = await Promise.all( reqList );

    const usage: ICommonRes = usageGroup.reduce(( pre: any, cur: any ) => ({
        items: pre.items.concat( cur.items ),
        totalRows: pre.totalRows + cur.totalRows
    }), {
        items: [],
        totalRows: 0
    });

    return usage;

};

export const changeSubName = ( subId: number, title: string ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.patch( `/cloud/subscriptions/title`, {

            id: subId,
            title

        }).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

// 合并返回结果
const appendAssociationResults = (
    deviceResults: Record<string, IDeviceAssociationResultItem>,
    batchResult: IBatchDeviceAssociationResponse,
    type: 'associate' | 'unassociate'
): void => {

    for ( const uid of batchResult.successUids ) {

        deviceResults[uid] = {
            status: 'success',
            type
        };

    }

    for ( const failedDevice of batchResult.failedDevices ) {

        deviceResults[failedDevice.uid] = {
            status: 'failed',
            type,
            reason: failedDevice.reason
        };

    }

};

export const changeAssociate = async (
    args: IChangeAssociateDevicesArgs
): Promise<IChangeAssociateDevicesResponse> => {

    const deviceResults: Record<string, IDeviceAssociationResultItem> = {};
    const associateDevices = args.associateDevices ?? [];
    const unassociateDevices = args.unassociateDevices ?? [];
    const batchRequests: Array<{
        devices: IDeviceAssociation[];
        endpoint: string;
        payloadKey: 'associateDevices' | 'unassociateDevices';
        type: 'associate' | 'unassociate';
    }> = [];

    if ( unassociateDevices.length > 0 ) {

        batchRequests.push({
            devices: unassociateDevices,
            endpoint: '/cloud/subscriptions/devices/unassociation/batch',
            payloadKey: 'unassociateDevices',
            type: 'unassociate'
        });

    }

    if ( associateDevices.length > 0 ) {

        batchRequests.push({
            devices: associateDevices,
            endpoint: '/cloud/subscriptions/devices/association/batch',
            payloadKey: 'associateDevices',
            type: 'associate'
        });

    }

    for ( const batchParams of batchRequests ) {

        const batchResult = await batchRequest( batchParams.devices, {
            batchSize: 100,
            concurrency: 2,
            createInitialResult: () => ({
                successUids: [],
                failedDevices: []
            }),
            request: async ( chunk ) => {

                try {

                    const { data } = await http.post<IBatchDeviceAssociationResponse>(
                        batchParams.endpoint,
                        { [batchParams.payloadKey]: chunk }
                    );
                    return data;

                } catch ( err ) {

                    console.log( err );
                    return {
                        successUids: [],
                        failedDevices: chunk.map( device => ({
                            uid: device.uid,
                            reason: EAssociateFailedReason.OTHER
                        }))
                    };

                }

            },
            merge: (
                target: IBatchDeviceAssociationResponse,
                source: IBatchDeviceAssociationResponse
            ): void => {

                target.successUids.push( ...source.successUids );
                target.failedDevices.push( ...source.failedDevices );

            }
        });
        appendAssociationResults( deviceResults, batchResult, batchParams.type );

    }

    return { deviceResults };

};

export const setVideoRetention = ( devices: Array<{
    uid: string;
    retentionDays: number;
}>, subscription: string ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.patch( `/cloud/subscriptions/devices/retention-days`, {
            devices: devices,
            subscription: subscription
        }).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const deviceConsumerSwitch = ( uid: string, consumeNdp: boolean = true ): Promise<void> => {

    return new Promise(( resolve, reject ) => {

        http.post( `/cloud/traffic/devices`,
            {
                'uid': uid,
                'consumeNdp': consumeNdp
            }
        ).then( res => {

            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

};

export const getCloudCountries = async ( lang: string ): Promise<IGetCloudCountriesResponse> => {

    const res = await http.get( `/cloud/subscriptions/countries?lang=${lang}` );
    return res.data;

};
